<template>
  <div data-id-e2e="btnDuplicateRenderer">
    <v-tooltip location="bottom">
      <template #activator="{ props: tooltipActivatorProps }">
        <v-btn
          data-id-e2e="btnDuplicateExtracts"
          v-bind="{ ...tooltipActivatorProps }"
          icon
          variant="text"
          :disabled="isDisabled"
          @click="() => onRouteClick()"
        >
          <v-icon size="23">mdi-content-copy</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('actions.duplicate') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { get } from 'lodash';
import { mapState, mapActions } from 'pinia';
import to from 'await-to-js';
import reportingMetrics from '@enums/reporting-metrics';
import { useCompoundExtractStore } from '@/stores/compound-extract';
import { useContextStore } from '@/stores/context';
import { usePermission } from '@/composables/use-permission';

export default {
  setup() {
    const { canDuplicateCompoundExtracts } = usePermission();
    const context = useContextStore();

    return {
      canDuplicateCompoundExtracts,
      bundlesEnabled: context.bundlesEnabled,
    };
  },

  data() {
    return {};
  },

  computed: {
    ...mapState(useCompoundExtractStore, ['getExtractById', 'getSettingsById']),

    extractId() {
      return get(this.params, 'extractId');
    },

    extract() {
      return this.getExtractById(this.extractId) || {};
    },

    isDisabled() {
      return !this.canDuplicateCompoundExtracts;
    },
  },

  methods: {
    ...mapActions(useCompoundExtractStore, ['duplicateExtract', 'setIsProcessing']),

    async onRouteClick() {
      this.setIsProcessing(true);
      const extractDuplication = {
        type: this.params.type,
        existingSeries: this.params.extractSeries,
        existingSettingsId: this.params.extractSettingsId,
        extractId: this.extractId,
      };

      const [err, newExtract] = await to(this.duplicateExtract(extractDuplication));
      this.setIsProcessing(false);
      if (err) return;

      const query = {
        ...this.$route.query,
        metricValue: reportingMetrics.sales,
        workpackageIds: newExtract.series.workpackageIds,
      };

      this.$router.push({
        name: `${this.params.extractSeries.type}-extract`,
        params: { extractSeriesId: newExtract.series._id },
        query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

a {
  text-decoration: none;
}

:deep(.duplicate-extracts__button) {
  height: 29px !important;
  padding: 0 12px !important;

  > span {
    font-size: 1.4rem;
  }
}

:deep(.generating-row .generating-text) {
  margin: 0px 4px 0px 8px;
  font-size: 14px;
}
</style>
